export const TEMPLATE_MODAL_BACKDROP_Z_INDEX = 360;
export const TEMPLATE_MODAL_PANEL_Z_INDEX = 361;
export const TEMPLATE_MODAL_SETTINGS_POPOVER_Z_INDEX = 390;
export const TEMPLATE_MODAL_CANVAS_PICKER_BACKDROP_Z_INDEX = 401;
export const TEMPLATE_MODAL_CANVAS_PICKER_PANEL_Z_INDEX = 402;
export const APP_LIGHTBOX_Z_INDEX = 420;
export const TEMPLATE_MODAL_SOURCE_PICKER_BACKDROP_Z_INDEX = 421;
export const TEMPLATE_MODAL_SOURCE_PICKER_PANEL_Z_INDEX = 422;
export const INLINE_CONTROL_TOOLTIP_Z_INDEX = 430;